<template>
    <div class="container">
        <!-- BUTTON: BACK -->
        <button class="btn btn-light mt-3" v-on:click="$router.back()">
            {{ $t('back') }}
        </button>
        <div class="row mt-md-3">
            <!-- CREATE ROLE FORM -->
            <div class="col-sm-5 offset-1">
                <ValidationObserver v-slot="{ handleSubmit }">
                    <form role="form" @submit.prevent="handleSubmit(submit)">
                        <!-- NAME -->
                        <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
                            <label for="name">{{ $t('name') }}</label>
                            <input
                                type="text"
                                id="name"
                                class="form-control"
                                v-model="role.name"
                                v-on:blur="generateSlug"
                            />
                            <div class="invalid-feedback" style="display: block">
                                <span>{{ $t(errors[0]) }}</span>
                            </div>
                        </ValidationProvider>
                        <!-- SLUG -->
                        <ValidationProvider name="Slug" rules="required" v-slot="{ errors }">
                            <label for="slug">{{ $t('slug') }}</label>
                            <input type="text" id="slug" class="form-control" v-model="role.slug" />
                            <div class="invalid-feedback" style="display: block">
                                <span>{{ $t(errors[0]) }}</span>
                            </div>
                            <div class="alert alert-danger mt-3" v-show="error.slug" role="alert">
                                <div v-for="(item, index) in error.slug" v-bind:key="index">
                                    {{ item }}
                                </div>
                            </div>
                        </ValidationProvider>
                        <!-- DESCRIPTION -->
                        <div class="form-group">
                            <label for="description">{{ $t('description') }}</label>
                            <textarea class="form-control" id="description" v-model="role.description"></textarea>
                        </div>
                        <!-- BUTTON: SUBMIT -->
                        <input type="submit" class="btn btn-success mt-2" :value="$t('save')" />
                    </form>
                </ValidationObserver>
            </div>
            <!-- PERMISSIONS TABLE -->
            <div class="col-sm-4 offset-1">
                <div class="alert alert-danger mt-3" v-show="invalidPermissions" role="alert">
                    Pick at least one permission
                </div>
                <table class="table table-borderless table-hover">
                    <thead>
                        <tr>
                            <th>{{ $t('permissions') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="permission of permissionsList"
                            v-bind:key="permission"
                            v-on:click="() => addPermission(permission)"
                        >
                            <td>
                                <div class="row">
                                    <div class="col-sm-10">
                                        {{ $t(`permission_${permission}`) }}
                                    </div>
                                    <div class="col-sm-2">
                                        <img
                                            src="@/assets/images/done.svg"
                                            alt=""
                                            class="doctype-icon"
                                            v-if="role.permissions.includes(permission)"
                                        />
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { createRole, handleAxiosError } from '@/services/axiosService';
import { permissions } from '@/services/roleService';

export default {
    data() {
        return {
            submitted: false,
            success: false,
            role: {
                name: null,
                slug: null,
                description: null,
                permissions: []
            },
            permissionsList: permissions,
            error: {},
            errors: [],
            invalidPermissions: false
        };
    },
    methods: {
        // add permission to role
        addPermission(id) {
            if (!this.role.permissions.includes(id)) {
                this.role.permissions.push(id);
            } else {
                this.role.permissions = this.role.permissions.filter(permissionId => {
                    return permissionId !== id;
                });
            }
            if (!this.isPermissionsEmpty()) {
                this.invalidPermissions = false;
            }
        },
        // format slug based on role name
        generateSlug() {
            this.role.slug = _.snakeCase(this.role.name);
        },
        // check if permission is empty
        isPermissionsEmpty() {
            return this.role.permissions.length === 0;
        },
        // submit form
        async submit() {
            if (this.isPermissionsEmpty()) {
                this.invalidPermissions = true;
            } else {
                try {
                    await createRole(this.role);
                    this.$toastr.s(this.$t('created'));
                    this.$router.push({ name: 'role.index' });
                } catch (error) {
                    handleAxiosError(error);
                }
            }
        }
    }
};
</script>
